import { Campaign } from '@/services'
import { getResponse } from '@/plugins/store'

export default {
  async getListCampaign({ commit }, params) {
    commit('GET_LIST_CAMPAIGN_REQUEST')
    try {
      const { data } = await Campaign.getListCampaign(params)
      commit('GET_LIST_CAMPAIGN_SUCCESS', getResponse(data))
    } catch (error) {
      commit('GET_LIST_CAMPAIGN_FAILURE', error)
    }
  },

  async getListAdGroupSpp({ commit }, params) {
    commit('GET_LIST_AD_GROUP_SPP_REQUEST')
    try {
      const { data } = await Campaign.getListAdGroupSpp(params)
      commit('GET_LIST_AD_GROUP_SPP_SUCCESS', getResponse(data))
    } catch (error) {
      commit('GET_LIST_AD_GROUP_SPP_FAILURE', error)
    }
  },

  async getListAd({ commit }, params) {
    commit('GET_LIST_AD_REQUEST')
    try {
      const { data } = await Campaign.getListAdCampaignSpp(params)
      commit('GET_LIST_AD_SUCCESS', getResponse(data))
    } catch (error) {
      commit('GET_LIST_AD_FAILURE', error)
    }
  },

  async getCampaignDetail({ commit }, params) {
    commit('GET_LIST_CAMPAIGN_DETAIL_REQUEST')
    try {
      const { data } = await Campaign.getListCampaign(params)
      commit('GET_LIST_CAMPAIGN_DETAIL_SUCCESS', getResponse(data))
    } catch (error) {
      commit('GET_LIST_CAMPAIGN_DETAIL_FAILURE', error)
    }
  },

  async getListAdGroupCampaign({ commit }, params) {
    commit('GET_LIST_AD_GROUP_CAMPAIGN_REQUEST')
    try {
      const { data } = await Campaign.getListAdGroup(params)
      commit('GET_LIST_AD_GROUP_CAMPAIGN_SUCCESS', getResponse(data))
    } catch (error) {
      commit('GET_LIST_AD_GROUP_CAMPAIGN_FAILURE', error)
    }
  },

  async getListAdCampaignSpp({ commit }, params) {
    commit('GET_LIST_AD_CAMPAIGN_SPP_REQUEST')
    try {
      const { data } = await Campaign.getListAdCampaignSpp(params)
      commit('GET_LIST_AD_CAMPAIGN_SPP_SUCCESS', getResponse(data))
    } catch (error) {
      commit('GET_LIST_AD_CAMPAIGN_SPP_FAILURE', error)
    }
  },

  async getListAdCampaignSp({ commit }, params) {
    commit('GET_LIST_AD_CAMPAIGN_SP_REQUEST')
    try {
      const { data } = await Campaign.getListAdCampaignSp(params)
      commit('GET_LIST_AD_CAMPAIGN_SP_SUCCESS', getResponse(data))
    } catch (error) {
      commit('GET_LIST_AD_CAMPAIGN_SP_FAILURE', error)
    }
  },

  async getListAdCampaignManual({ commit }, params) {
    commit('GET_LIST_AD_CAMPAIGN_MANUAL_REQUEST')
    try {
      const { data } = await Campaign.getListAdCampaignManual(params)
      commit('GET_LIST_AD_CAMPAIGN_MANUAL_SUCCESS', getResponse(data))
    } catch (error) {
      commit('GET_LIST_AD_CAMPAIGN_MANUAL_FAILURE', error)
    }
  },

  async getListIdentity({ commit }, params) {
    commit('GET_LIST_IDENTITY_REQUEST')
    try {
      const { data } = await Campaign.getListIdentity(params)
      commit('GET_LIST_IDENTITY_SUCCESS', getResponse(data))
    } catch (error) {
      commit('GET_LIST_IDENTITY_FAILURE', error)
    }
  },

  async getListVideoTikTok({ commit }, params) {
    commit('GET_LIST_VIDEO_TIKTOK_REQUEST')
    try {
      const { data } = await Campaign.getListVideoTikTok(params)
      commit('GET_LIST_VIDEO_TIKTOK_SUCCESS', getResponse(data))
    } catch (error) {
      commit('GET_LIST_VIDEO_TIKTOK_FAILURE', error)
    }
  },

  async getListVideoCreative({ commit }, params) {
    commit('GET_LIST_VIDEO_CREATIVE_REQUEST')
    try {
      const { data } = await Campaign.getListVideoCreative(params)
      commit('GET_LIST_VIDEO_CREATIVE_SUCCESS', getResponse(data))
    } catch (error) {
      commit('GET_LIST_VIDEO_CREATIVE_FAILURE', error)
    }
  },

  async getThumbnailVideoCreative({ commit }, params) {
    commit('GET_THUMBNAIL_VIDEO_CREATIVE_REQUEST')
    try {
      const { data } = await Campaign.getThumbnailVideoCreative(params)
      commit('GET_THUMBNAIL_VIDEO_CREATIVE_SUCCESS', getResponse(data))
    } catch (error) {
      commit('GET_THUMBNAIL_VIDEO_CREATIVE_FAILURE', error)
    }
  },

  async getListVideoLibrary({ commit }, params) {
    commit('GET_LIST_VIDEO_LIBRARY_REQUEST')
    try {
      const { data } = await Campaign.getListVideoLibrary(params)
      commit('GET_LIST_VIDEO_LIBRARY_SUCCESS', getResponse(data))
    } catch (error) {
      commit('GET_LIST_VIDEO_LIBRARY_FAILURE', error)
    }
  },

  async syncVideoToAdAccount({ commit }, params) {
    commit('SYNC_VIDEO_TO_AD_ACCOUNT_REQUEST')
    try {
      const { data } = await Campaign.syncVideoToAdAccount(params)
      commit('SYNC_VIDEO_TO_AD_ACCOUNT_SUCCESS', getResponse(data))
    } catch (error) {
      commit('SYNC_VIDEO_TO_AD_ACCOUNT_FAILURE', error)
    }
  },

  async duplicateCampaigns({ commit }, params) {
    commit('DUPLICATE_CAMPAIGN_REQUEST')
    try {
      const { data } = await Campaign.duplicateCampaigns(params)
      commit('DUPLICATE_CAMPAIGN_SUCCESS', getResponse(data))
    } catch (error) {
      commit('DUPLICATE_CAMPAIGN_FAILURE', error)
    }
  },

  async updateStatusCampaign({ commit }, params) {
    commit('UPDATE_STATUS_CAMPAIGN_REQUEST')
    try {
      const { data } = await Campaign.updateStatusCampaign(params)
      commit('UPDATE_STATUS_CAMPAIGN_SUCCESS', getResponse(data))
    } catch (error) {
      commit('UPDATE_STATUS_CAMPAIGN_FAILURE', error)
    }
  },

  async updateStatusAdGroup({ commit }, params) {
    commit('UPDATE_STATUS_AD_GROUP_REQUEST')
    try {
      const { data } = await Campaign.updateStatusAdGroup(params)
      commit('UPDATE_STATUS_AD_GROUP_SUCCESS', getResponse(data))
    } catch (error) {
      commit('UPDATE_STATUS_AD_GROUP_FAILURE', error)
    }
  },

  async updateStatusAd({ commit }, params) {
    commit('UPDATE_STATUS_AD_REQUEST')
    try {
      const { data } = await Campaign.updateStatusAd(params)
      commit('UPDATE_STATUS_AD_SUCCESS', getResponse(data))
    } catch (error) {
      commit('UPDATE_STATUS_AD_FAILURE', error)
    }
  },

  async getListLocation({ commit }, params) {
    commit('GET_LIST_LOCATION_REQUEST')
    try {
      const { data } = await Campaign.getListLocation(params)
      commit('GET_LIST_LOCATION_SUCCESS', getResponse(data))
    } catch (error) {
      commit('GET_LIST_LOCATION_FAILURE', error)
    }
  },
}
